import { ComponentPropsWithoutRef, forwardRef } from "react";
import { Icon } from "./EditIcon.Parts";

export const EditIcon = forwardRef<
  SVGSVGElement,
  ComponentPropsWithoutRef<"svg"> & { small?: boolean }
>(({ small, ...props }, ref) => (
  <Icon
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    $small={small}
    ref={ref}
    {...props}
  >
    <path
      d="M0.620117 19.9276V13.428C0.620117 13.2205 0.788533 13.0526 0.995566 13.0526H2.39009C2.59766 13.0526 2.76554 13.221 2.76554 13.428V17.7816C2.76554 17.9892 2.93341 18.1571 3.14098 18.1571H8.56192C8.76949 18.1571 8.93737 18.325 8.93737 18.5325V19.9271C8.93737 20.1346 8.76949 20.3025 8.56192 20.3025H0.995566C0.787996 20.3025 0.620117 20.1346 0.620117 19.9271V19.9276Z"
      fill="currentColor"
    />
    <path
      d="M20.5108 4.55243L16.3707 0.412309C16.2243 0.265884 15.9861 0.265884 15.8397 0.412309L6.87455 9.37748C6.82091 9.43111 6.78497 9.49923 6.77103 9.57378L5.81417 14.6713C5.76536 14.9309 5.99278 15.1583 6.25237 15.1095L11.3499 14.1526C11.4244 14.1387 11.4926 14.1028 11.5462 14.0491L20.5114 5.08396C20.6578 4.93753 20.6578 4.69939 20.5114 4.55297L20.5108 4.55243ZM10.4976 12.0625C10.444 12.1161 10.3759 12.152 10.3013 12.166L8.93951 12.4218C8.67992 12.4706 8.4525 12.2432 8.50131 11.9836L8.75715 10.6218C8.7711 10.5473 8.80703 10.4792 8.86067 10.4255L13.1097 6.17651C13.2561 6.03009 13.4942 6.03009 13.6407 6.17651L14.7466 7.28248C14.8931 7.4289 14.8931 7.66704 14.7466 7.81347L10.4976 12.0625ZM17.4767 5.08342L16.795 5.76513C16.6485 5.91155 16.4104 5.91155 16.264 5.76513L15.158 4.65917C15.0116 4.51274 15.0116 4.2746 15.158 4.12817L15.8397 3.44647C15.9861 3.30004 16.2243 3.30004 16.3707 3.44647L17.4767 4.55243C17.6231 4.69886 17.6231 4.937 17.4767 5.08342Z"
      fill="currentColor"
    />
  </Icon>
));
